import { render, staticRenderFns } from "./NavBtn.vue?vue&type=template&id=3bfe384a&scoped=true&"
import script from "./NavBtn.vue?vue&type=script&lang=js&"
export * from "./NavBtn.vue?vue&type=script&lang=js&"
import style0 from "./NavBtn.vue?vue&type=style&index=0&id=3bfe384a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe384a",
  null
  
)

export default component.exports